import type { User } from '@rewardopl/types';

export function isLoggedIn(user: User | null): user is User {
  return Boolean(user);
}

export function isLoggedOut(user: User | null): user is null {
  return !isLoggedIn(user);
}
